'use strict';

// 一覧（成績表一覧・対局一覧）の絞り込みモーダル（HAML は shared/_match_list_filter_modal、見た目は components/_match_list_filter.scss）
// 開閉は point_calendars/daily_matches_modal.js、名前検索は components/player_select_modal.js に倣う。
// document に委譲するので Turbolinks の画面遷移後も再登録は要らない。UI 文言はすべて HAML で出す
const MODAL_SELECTOR = '#match-list-filter-modal';
const PANEL_SELECTOR = '.match-list-filter-modal';
const NAMESPACE = '.matchListFilter';

// 開始日 > 終了日を選びにくくするため、互いの入力欄の min / max を連動させる
function syncDateLimits($modal) {
  const $from = $modal.find('.js-match-list-filter-date-from');
  const $to = $modal.find('.js-match-list-filter-date-to');
  $to.attr('min', $from.val() || null);
  $from.attr('max', $to.val() || null);
}

// 名前検索（前後の空白を除き、大文字小文字を区別しない部分一致）
function applySearch($modal) {
  const query = String($modal.find('.js-match-list-filter-search').val() || '').trim().toLowerCase();
  let visibleCount = 0;
  $modal.find('.js-match-list-filter-player').each(function () {
    const name = String($(this).data('player-name') || '').toLowerCase();
    const matched = query === '' || name.indexOf(query) !== -1;
    $(this).toggleClass('d-none', !matched);
    if (matched) visibleCount += 1;
  });
  $modal.find('.js-match-list-filter-search-empty').toggleClass('d-none', visibleCount > 0);
}

// 入力を描画時の条件に戻す（閉じたあとに開き直したとき、適用していない変更を残さない）
function resetForm($modal) {
  const form = $modal.find('form').get(0);
  if (form) form.reset();
  $modal.find('.js-match-list-filter-search').val('');
  applySearch($modal);
  syncDateLimits($modal);
}

function openModal() {
  const $modal = $(MODAL_SELECTOR);
  if ($modal.length === 0) return;

  resetForm($modal);
  const $panel = $modal.find(PANEL_SELECTOR);
  $modal.css('display', 'flex').addClass('starting');
  $panel.addClass('starting');
  $('body').css('overflow', 'hidden');
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      $modal.removeClass('starting');
      $panel.removeClass('starting');
    });
  });
  $panel.trigger('focus');

  $(document).on('keydown' + NAMESPACE, function (e) {
    if (e.key === 'Escape') closeModal();
  });
}

function closeModal() {
  const $modal = $(MODAL_SELECTOR);
  if (!$modal.is(':visible')) return;

  const $panel = $modal.find(PANEL_SELECTOR);
  $modal.addClass('starting');
  $panel.addClass('starting');
  let finished = false;
  const end = function () {
    if (finished) return;
    finished = true;
    $modal.off('transitionend', end);
    $modal.hide();
  };
  $modal.on('transitionend', end);
  setTimeout(end, 420);
  $('body').css('overflow', '');
  $(document).off('keydown' + NAMESPACE);
  $('.js-match-list-filter-open').trigger('focus');
}

// アニメーションなしで閉じた状態に戻す（Turbolinks のキャッシュ前・bfcache からの復元）
function resetModal() {
  const $modal = $(MODAL_SELECTOR);
  $(document).off('keydown' + NAMESPACE);
  if ($modal.length === 0) return;

  $modal.hide().removeClass('starting');
  $modal.find(PANEL_SELECTOR).removeClass('starting');
  $('body').css('overflow', '');
  $modal.find('.js-match-list-filter-search').val('');
  applySearch($modal);
}

$(document).on('click', '.js-match-list-filter-open', function () {
  openModal();
});

$(document).on('click', '.js-match-list-filter-close', function () {
  closeModal();
});

$(document).on('click', MODAL_SELECTOR, function (e) {
  if (e.target === this) closeModal();
});

$(document).on('input', '.js-match-list-filter-search', function () {
  applySearch($(MODAL_SELECTOR));
});

// 名前検索欄での Enter（スマホの「検索」キーも同じ）で暗黙にフォームを送信しない
$(document).on('keydown', '.js-match-list-filter-search', function (e) {
  if (e.key === 'Enter') e.preventDefault();
});

$(document).on('change', '.js-match-list-filter-date-from, .js-match-list-filter-date-to', function () {
  syncDateLimits($(MODAL_SELECTOR));
});

$(document).on('turbolinks:before-cache', resetModal);

// GET フォーム送信後にブラウザの戻るで bfcache から復元されたとき。pageshow は document へバブリングしない
window.addEventListener('pageshow', function (e) {
  if (e.persisted) resetModal();
});
